import { FunctionaryOption } from '../types/systemConfiguration/functionariesSwitch';

export const formatFunctionaries = (list: any[]): FunctionaryOption[] =>
    (list ?? []).map((f: any) => ({
        id: f.id,
        name: `${f.label}`.trim(),
        positionName: f.positionName ?? f.position?.name ?? '',
        fname: f.name ?? '',
        lastname: f.lastname ?? '',
        email: f.email ?? '',
        extension: f.extension ?? '',
    }));
